import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "components/Button";
import ChartComponent from "components/Chart/Chart";
import Flame from "components/Flame/Flame";
import Layout from "components/Layout";
import { FunctionComponent } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

import { faDiscord } from "@fortawesome/free-brands-svg-icons";

type Props = {};

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-decoration: none;

  svg {
    margin-left: 8px;
  }
`;

const data = {
  labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
  datasets: [
    {
      label: "# of Votes",
      data: [12, 19, 3, 5, 2, 3],
      backgroundColor: [
        "rgba(255, 99, 132, 0.2)",
        "rgba(54, 162, 235, 0.2)",
        "rgba(255, 206, 86, 0.2)",
        "rgba(75, 192, 192, 0.2)",
        "rgba(153, 102, 255, 0.2)",
        "rgba(255, 159, 64, 0.2)",
      ],
      borderColor: [
        "rgba(255, 99, 132, 1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
        "rgba(255, 159, 64, 1)",
      ],
      borderWidth: 1,
    },
  ],
};

const IndexPage: FunctionComponent<Props> = ({}) => {
  return (
    <Layout>
      {/* <Head>
        <meta property="og:title" content="Home | Deck Generator Baseball Superstars 2020"></meta>
        <meta property="og:description" content="Decks generator for Baseball Superstars 2020"></meta>
        <title>Home | Deck Generator Baseball Superstars 2020</title>
      </Head> */}

      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div style={{ marginBottom: "16px" }}>Welcome!</div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, 300px)",
            gridGap: "16px",
          }}
        >
          <NavLink to="/decks">
            <StyledButton active>Generate Decks</StyledButton>
          </NavLink>

          <NavLink to="/roster">
            <StyledButton>Create or Import your roster</StyledButton>
          </NavLink>

          <a href="https://discord.gg/Rc4zqpxYFU" target="_blank">
            <StyledButton style={{ background: "#570588;" }}>
              Join us for more help
              <FontAwesomeIcon icon={faDiscord} size="2x" />{" "}
            </StyledButton>
          </a>
        </div>
      </div>
    </Layout>
  );
};

export default IndexPage;
